import { STATUS_META, POLICY_META } from "@/lib/api";

const TONES = {
  blue: "bg-[rgba(79,142,247,0.16)] text-[#7FAEF9]",
  green: "bg-[rgba(34,197,94,0.16)] text-[#4ADE80]",
  amber: "bg-[rgba(245,158,11,0.16)] text-[#FBBF24]",
  red: "bg-[rgba(239,68,68,0.16)] text-[#F87171]",
  violet: "bg-[rgba(139,92,246,0.16)] text-[#A78BFA]",
  neutral: "bg-[rgba(163,163,163,0.12)] text-[#A3A3A3]",
};

export const Chip = ({ tone = "neutral", children, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-0.5 text-[11px] font-medium ${TONES[tone]}`}
  >
    {children}
  </span>
);

export const StatusChip = ({ status, testId }) => {
  const meta = STATUS_META[status] || { label: status, tone: "neutral" };
  return <Chip tone={meta.tone} testId={testId}>{meta.label}</Chip>;
};

export const PolicyChip = ({ policyStatus, testId }) => {
  const meta = POLICY_META[policyStatus] || { label: policyStatus, tone: "neutral" };
  return <Chip tone={meta.tone} testId={testId}>{meta.label}</Chip>;
};
